/**
 *  mutations 类型声明
 * */
export const SET_LOGIN_STATE = 'set_login_state'

export const SET_TOKEN = 'set_token'

export const SET_USERINFO = 'set_userinfo'

export const SET_PAY_PASS = 'set_pay_pass'

export const SET_ADDRESS = 'set_address'

export const SET_POST_APPRAISES_INFO = 'set_post_appraises_info'

export const SET_ORDER_NUM = 'set_order_num'

export const BACK_REFUNDS = 'back_refunds'

export const SET_ABLE_SCORE = 'set_able_score'

export const SET_UNPACK_SCORE = 'set_unpack_score'

export const SET_RECHARGE_SCORE = 'set_recharge_score'

export const SET_EXCHANGE_INFO = 'set_exchange_info'

export const SET_ORDER_SCORE_DETAIL = 'set_order_score_detail'

export const SET_SCORE_EXCHANGE_ID = 'set_score_exchange_id'

export const SET_CONFIRM_ORDER_GOODS = 'set_confirm_order_goods'

export const SET_PAY_SUCE_ORDER_ID = 'set_pay_suce_order_id'

export const HAS_CREATED_ORDER = 'has_created_order'

export const SET_CREATED_ORDER_ID = 'set_created_order_id'

export const SET_NEWS_CONTENT = 'set_news_content'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js